import { useLang } from "../../i18n/LanguageContext";

export const WhatsAppFloat = () => {
    const { t, waUrl } = useLang();

    return (
        <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t.wa.label}
            data-testid="whatsapp-float"
            className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-[0_14px_34px_-10px_rgba(37,211,102,0.65)] transition-transform hover:scale-[1.04] focus-visible:outline-ambar"
        >
            <svg
                aria-hidden="true"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
            >
                <path d="M20.52 3.48A11.78 11.78 0 0 0 12.05 0C5.5 0 .2 5.3.2 11.86a11.8 11.8 0 0 0 1.63 6l-1.74 6.35 6.5-1.7a11.82 11.82 0 0 0 5.46 1.4h.01c6.55 0 11.86-5.3 11.86-11.86A11.82 11.82 0 0 0 20.52 3.48ZM12.06 21.6h-.01a9.83 9.83 0 0 1-5-1.37l-.36-.21-3.86 1.01 1.03-3.76-.23-.39a9.78 9.78 0 0 1-1.5-5.22c0-5.42 4.42-9.84 9.86-9.84a9.78 9.78 0 0 1 6.96 2.88 9.78 9.78 0 0 1 2.88 6.96c0 5.43-4.42 9.84-9.86 9.84Zm5.4-7.37c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.78.97-.95 1.17-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48a9 9 0 0 1-1.66-2.06c-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5l-.57-.01a1.1 1.1 0 0 0-.8.37c-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.3 1.26.48 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
            </svg>
            <span className="text-sm font-semibold">WhatsApp</span>
        </a>
    );
};
